const handlersMiddleware = (
  value: string,
  helpers: ((value: string) => string)[],
) => {
  return helpers.reduce((previousValue, helper) => {
    return helper(previousValue);
  }, value);
};

export default handlersMiddleware;
